import { render, staticRenderFns } from "./EditTodoItemType.vue?vue&type=template&id=0e509602"
import script from "./EditTodoItemType.vue?vue&type=script&lang=js"
export * from "./EditTodoItemType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports